import { Flex } from 'antd'
import { GetPlastic } from 'features/card/get-plastic-card'
import { GetVirtualCard } from 'features/card/get-virtual-card/ui/GetVirtualCard'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { selectCurrentAccountObject } from 'shared/config/store/selectors'
import { useResultModal } from 'shared/libs/hooks/useResultModal/useResultModal'
import { ActionButton } from 'shared/ui'
import CardIcon from 'shared/ui/CardIcon/CardIcon'
import { getSpendableBalance } from 'shared/libs/utils/balance';

export const GetCards = () => {
  const { formatMessage: t } = useIntl();
  const [showPlastic, setShowPlastic] = useState(false);
  const [showVirtual, setShowVirtual] = useState(false);
  const currentAccount = useSelector(selectCurrentAccountObject);
  const { showResult } = useResultModal();

  const closePlastic = () => {
    setShowPlastic(false);
  }

  const closeVirtual = () => {
    setShowVirtual(false);
  }

  const onClickVirtual = () => {
    if (!currentAccount || getSpendableBalance(currentAccount.available) < 3) {
      showResult({ type: 'warning', title: t({ id: "card.virtual.messages.topup" }) });
      return
    }
    setShowVirtual(true);
  }

  const onClickPlastic = () => {
    const MIN_TOPUP_AMOUNT = 7;
    if (!currentAccount || getSpendableBalance(currentAccount.available) < MIN_TOPUP_AMOUNT) {
      showResult({ 
        type: 'warning', 
        title: t({ id: "card.getPlastic.messages.topup" }, { amount: MIN_TOPUP_AMOUNT }) 
      });
      return
    }
    setShowPlastic(true);
  }

  return (
    <>
      <Flex gap={10}>
        <ActionButton
          image={
            <CardIcon
              size="s"
              cardNumber="••••"
            />
          }
          text={t({id: 'river.plasticCard'})}
          onClick={onClickPlastic}
        />
        <ActionButton
          image={<CardIcon
            size="s"
            cardNumber="••••"
          />}
          text={t({id: 'river.virtualCard'})}
          onClick={onClickVirtual}
        />
        <GetPlastic open={showPlastic} onClose={closePlastic} />
        <GetVirtualCard open={showVirtual} onClose={closeVirtual} />
      </Flex>
    </>
  )
}